import Vue from 'vue'
import H5Page from './H5Page.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(H5Page),
}).$mount('#app')
